import { action, makeObservable, observable } from 'mobx'

import { IAnalyticSettingsField, IAnalyticsSettings } from '~/client/graph'
import AnalyticsReportsType, {
  analyticsReportsTypeLabel,
} from '~/client/src/shared/enums/AnalyticReportsType'
import { SAVE_ANALYTICS_SETTING } from '~/client/src/shared/stores/EventStore/eventConstants'
import EventsStore from '~/client/src/shared/stores/EventStore/Events.store'

export default class AnalyticsSettingsStore {
  @observable private settings: IAnalyticsSettings

  @observable public isDataReceived: boolean = false

  public constructor(private readonly eventsStore: EventsStore) {
    makeObservable(this)
  }

  public get mySettingFields() {
    return this.settings?.fields || []
  }

  private get defaultSettings(): IAnalyticsSettings {
    return {
      projectId: this.eventsStore.appState.activeProject.id,
      fields: [
        {
          type: AnalyticsReportsType.DELIVERY_REPORT,
          name: analyticsReportsTypeLabel[AnalyticsReportsType.DELIVERY_REPORT],
          isEnabled: true,
        },
      ],
    }
  }

  @action.bound
  public receiveData(settings: IAnalyticsSettings) {
    this.settings = settings || this.defaultSettings
    this.isDataReceived = true
  }

  @action.bound
  public clearData() {
    this.settings = null
    this.isDataReceived = false
  }

  public updateSetting = (fields: IAnalyticSettingsField[]) => {
    this.eventsStore.dispatch(
      SAVE_ANALYTICS_SETTING,
      {
        ...this.settings,
        fields,
      },
      this.receiveData,
    )
  }
}
